/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AdminAssignRequest,
  AssignRequest,
  AssignmentAuthRequest,
  ConfirmRequest,
  ProblemDetails,
  RevokeRequest
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const postApiRfidAssignmentAuthenticate = (
    assignmentAuthRequest?: AssignmentAuthRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/rfidAssignment/authenticate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignmentAuthRequest, signal
    },
      options);
    }




export const getPostApiRfidAssignmentAuthenticateMutationOptions = <TError = void | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentAuthenticate>>, TError,{data?: AssignmentAuthRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentAuthenticate>>, TError,{data?: AssignmentAuthRequest}, TContext> => {

const mutationKey = ['postApiRfidAssignmentAuthenticate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRfidAssignmentAuthenticate>>, {data?: AssignmentAuthRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRfidAssignmentAuthenticate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRfidAssignmentAuthenticateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRfidAssignmentAuthenticate>>>
    export type PostApiRfidAssignmentAuthenticateMutationBody = AssignmentAuthRequest | undefined
    export type PostApiRfidAssignmentAuthenticateMutationError = void | ProblemDetails

    export const usePostApiRfidAssignmentAuthenticate = <TError = void | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentAuthenticate>>, TError,{data?: AssignmentAuthRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRfidAssignmentAuthenticate>>,
        TError,
        {data?: AssignmentAuthRequest},
        TContext
      > => {
      return useMutation(getPostApiRfidAssignmentAuthenticateMutationOptions(options), queryClient);
    }
    export const postApiRfidAssignmentRequest = (
    assignRequest?: AssignRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/rfidAssignment/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignRequest, signal
    },
      options);
    }




export const getPostApiRfidAssignmentRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentRequest>>, TError,{data?: AssignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentRequest>>, TError,{data?: AssignRequest}, TContext> => {

const mutationKey = ['postApiRfidAssignmentRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRfidAssignmentRequest>>, {data?: AssignRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRfidAssignmentRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRfidAssignmentRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRfidAssignmentRequest>>>
    export type PostApiRfidAssignmentRequestMutationBody = AssignRequest | undefined
    export type PostApiRfidAssignmentRequestMutationError = unknown

    export const usePostApiRfidAssignmentRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentRequest>>, TError,{data?: AssignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRfidAssignmentRequest>>,
        TError,
        {data?: AssignRequest},
        TContext
      > => {
      return useMutation(getPostApiRfidAssignmentRequestMutationOptions(options), queryClient);
    }
    export const postApiRfidAssignmentConfirm = (
    confirmRequest?: ConfirmRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/rfidAssignment/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmRequest, signal
    },
      options);
    }




export const getPostApiRfidAssignmentConfirmMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentConfirm>>, TError,{data?: ConfirmRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentConfirm>>, TError,{data?: ConfirmRequest}, TContext> => {

const mutationKey = ['postApiRfidAssignmentConfirm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRfidAssignmentConfirm>>, {data?: ConfirmRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRfidAssignmentConfirm(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRfidAssignmentConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRfidAssignmentConfirm>>>
    export type PostApiRfidAssignmentConfirmMutationBody = ConfirmRequest | undefined
    export type PostApiRfidAssignmentConfirmMutationError = unknown

    export const usePostApiRfidAssignmentConfirm = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentConfirm>>, TError,{data?: ConfirmRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRfidAssignmentConfirm>>,
        TError,
        {data?: ConfirmRequest},
        TContext
      > => {
      return useMutation(getPostApiRfidAssignmentConfirmMutationOptions(options), queryClient);
    }
    export const postApiRfidAssignmentRevoke = (
    revokeRequest?: RevokeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/rfidAssignment/revoke`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revokeRequest, signal
    },
      options);
    }




export const getPostApiRfidAssignmentRevokeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentRevoke>>, TError,{data?: RevokeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentRevoke>>, TError,{data?: RevokeRequest}, TContext> => {

const mutationKey = ['postApiRfidAssignmentRevoke'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRfidAssignmentRevoke>>, {data?: RevokeRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRfidAssignmentRevoke(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRfidAssignmentRevokeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRfidAssignmentRevoke>>>
    export type PostApiRfidAssignmentRevokeMutationBody = RevokeRequest | undefined
    export type PostApiRfidAssignmentRevokeMutationError = unknown

    export const usePostApiRfidAssignmentRevoke = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentRevoke>>, TError,{data?: RevokeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRfidAssignmentRevoke>>,
        TError,
        {data?: RevokeRequest},
        TContext
      > => {
      return useMutation(getPostApiRfidAssignmentRevokeMutationOptions(options), queryClient);
    }
    export const postApiRfidAssignmentAssign = (
    adminAssignRequest?: AdminAssignRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/rfidAssignment/assign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminAssignRequest, signal
    },
      options);
    }




export const getPostApiRfidAssignmentAssignMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentAssign>>, TError,{data?: AdminAssignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentAssign>>, TError,{data?: AdminAssignRequest}, TContext> => {

const mutationKey = ['postApiRfidAssignmentAssign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRfidAssignmentAssign>>, {data?: AdminAssignRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRfidAssignmentAssign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRfidAssignmentAssignMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRfidAssignmentAssign>>>
    export type PostApiRfidAssignmentAssignMutationBody = AdminAssignRequest | undefined
    export type PostApiRfidAssignmentAssignMutationError = unknown

    export const usePostApiRfidAssignmentAssign = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRfidAssignmentAssign>>, TError,{data?: AdminAssignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRfidAssignmentAssign>>,
        TError,
        {data?: AdminAssignRequest},
        TContext
      > => {
      return useMutation(getPostApiRfidAssignmentAssignMutationOptions(options), queryClient);
    }
